import {
  addDays,
  isSunday,
  isSaturday,
  nextSaturday,
  nextSunday,
} from 'date-fns'
import type { DayTime } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

export const WEEK_DATES = {
  get today() {
    return new Date() // Сегодня
  },
  get tomorrow() {
    return addDays(this.today, 1) // Завтра
  },
  get saturday() {
    return nextSaturday(this.today) // Ближайшая суббота
  },
  get sunday() {
    // Если сегодня воскресенье
    if (isSunday(this.today)) {
      return addDays(this.today, 7) // Возвращаем следующее воскресенье
    }

    return nextSunday(this.today) // Ближайшее воскресенье
  },
  get isTodaySaturday() {
    return isSaturday(this.today) // true - если сегодня суббота
  },
}

export const DAY_TIMES: {
  // eslint-disable-next-line no-unused-vars
  [key in DayTime]: { name: string, time: string }
} = {
  morning: {
    name: 'Утро',
    time: '06:00 - 11:00',
  },
  afternoon: {
    name: 'День',
    time: '11:00 - 17:00',
  },
  evening: {
    name: 'Вечер',
    time: '17:00 - 24:00',
  },
}
